import { render, staticRenderFns } from "./CousrsesDetails.vue?vue&type=template&id=6f9f6c25&scoped=true"
import script from "./CousrsesDetails.vue?vue&type=script&lang=js"
export * from "./CousrsesDetails.vue?vue&type=script&lang=js"
import style0 from "./CousrsesDetails.vue?vue&type=style&index=0&id=6f9f6c25&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f9f6c25",
  null
  
)

export default component.exports